import { render, staticRenderFns } from "./modalIncidenciaAmostra.vue?vue&type=template&id=559e512e&"
import script from "./modalIncidenciaAmostra.vue?vue&type=script&lang=js&"
export * from "./modalIncidenciaAmostra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports